export default __webpack_public_path__ + "static/dumpster-5331829b2837bd7b816207f66100d016.svg";